module.exports = __webpack_public_path__ + "media/YBEN2.e589c119.mp4";